import { Suspense, React } from "react";
import BusinessSettingsContainer from "../../Containers/BusinessSettings";

const index = () => {
  return <Suspense fallback={<div></div>}>
           <BusinessSettingsContainer />
        </Suspense>;
};

export default index;
